export default "__VITE_ASSET__Asaqz6EW__"